import { makeStyles } from "@material-ui/core/styles";
import greenImg from "../../../images/contents/map/acos/green.png"
import orangeImg from "../../../images/contents/map/acos/orange.png"
import redImg from "../../../images/contents/map/acos/red.png"
import yellowImg from "../../../images/contents/map/acos/yellow.png"
import { Box, List, ListItemText, Tooltip } from "@material-ui/core";
import { LegendBoxList, LegendBoxListItem, LegendBoxListItemText } from "../../legend/LegendBoxComponents";
import { withStyles } from "@material-ui/styles";
import { memo } from "react";

const useStyles = makeStyles((theme) => ({
  icon: {
    verticalAlign: "middle"
  },
  legendBase: {
    display: "inline-block",
    height: 10,
    width: 30,
    border: 'solid 2px'
  },
  ft03: {
    backgroundColor: "rgba(220, 107, 44, 0.5)",
    borderColor: "rgba(220, 107, 44, 1.0)"
  },
  ft06: {
    backgroundColor: "rgba(234, 100, 255, 0.5)",
    borderColor: "rgba(234, 100, 255, 1.0)"
  },
  ft09: {
    backgroundColor: "rgba(76, 158, 8, 0.5)",
    borderColor: "rgba(76, 158, 8, 1.0)"
  },
  ft12: {
    backgroundColor: "rgba(255, 255, 0, 0.5)",
    borderColor: "rgba(255, 255, 0, 1.0)"
  },
  ft15: {
    backgroundColor: "rgba(73, 221, 194, 0.5)",
    borderColor: "rgba(73, 221, 194, 1.0)"
  },
  ft18: {
    backgroundColor: "rgba(35, 110, 241, 0.5)",
    borderColor: "rgba(35, 110, 241, 1.0)"
  },
  ft21: {
    backgroundColor: "rgba(197, 78, 160, 0.5)",
    borderColor: "rgba(197, 78, 160, 1.0)"
  },
  ft24: {
    backgroundColor: "rgba(106, 55, 167, 0.5)",
    borderColor: "rgba(106, 55, 167, 1.0)"
  },
  detachedVa: {
    borderColor: "rgba(220, 107, 44, 1.0)",
    backgroundImage: `linear-gradient(
      -45deg,
      rgba(255,255,255, 0) 40%,
      rgba(220, 107, 44, 1) 40%, rgba(220, 107, 44, 1) 50%,
      rgba(255,255,255, 0) 50%, rgba(255,255,255, 0) 90%,
      rgba(220, 107, 44, 1) 90%, rgba(220, 107, 44, 1)
    )`,
    backgroundSize: "7px 7px",
    minWidth: 30,
    marginTop: 3
  },
  flexList: {
    display: "flex",
    padding: 0
  }
}));

const AcosToolTip = withStyles(them => ({
  popper: {
    zIndex: 2500
  },
  tooltip: {
    whiteSpace: "pre-line",
    fontSize: 12,
    backgroundColor: "rgba(0, 0, 0, 0.9)"
  },
  arrow: {
    color: "rgba(0, 0, 0, 0.9)"
  }
}))(Tooltip);

const greenText = `Ash
Volcano is in a non-eruptive state. Or, after a change from a higher alert level
Volcanic activity considered to have ceased, and volcano reverted to a non-eruptive state.

Non Ash
Volcano is in a non-eruptive state. Or, after a change from a higher alert level
Volcanic activity considered to have ceased, and volcano reverted to a non-eruptive state.`;

const yellowText = `Ash
Volcano is experiencing signs of elevated unrest above known background levels
Or, after a change from a higher alert level;Volcanic activity has decreased significantly but continues to be closely monitored for possible renewed increase.

Non Ash
Volcano is experiencing signs of elevated unrest above known background levels. Ash emission has not resulted from any activity.`;

const orangeText = `Ash
Volcano is exhibiting heightened unrest considered to be typical, with increased likelihood of an eruption.
Or volcanic eruption is underway with a max top under FL200 with no or minor ash emission.

Non Ash
NIL`;
const redText = `Ash
Eruption is forecast to be imminent with significant emission of ash into the atmosphere likely, Or eruption is underway with significant emission of ash into the atmosphere
(over FL250 for South & Central America, and over FL200 for other regions or volcanic ash is near an airport).

Non Ash
NIL`;

function LegendAcos({legendBox: box}) {
  const classes = useStyles();

  return (
    <Box sx={{minWidth: 270, maxWidth: 290}}>
      <LegendBoxList>
        <LegendBoxListItem>
          <span className={`${classes.legendBase} ${classes.ft24}`} /><LegendBoxListItemText>FT 24H</LegendBoxListItemText>
        </LegendBoxListItem>
        <LegendBoxListItem>
          <span className={`${classes.legendBase} ${classes.ft21}`} /><LegendBoxListItemText>FT 21H</LegendBoxListItemText>
        </LegendBoxListItem>
        <LegendBoxListItem>
          <span className={`${classes.legendBase} ${classes.ft18}`} /><LegendBoxListItemText>FT 18H</LegendBoxListItemText>
        </LegendBoxListItem>
        <LegendBoxListItem>
          <span className={`${classes.legendBase} ${classes.ft15}`} /><LegendBoxListItemText>FT 15H</LegendBoxListItemText>
        </LegendBoxListItem>
        <LegendBoxListItem>
          <span className={`${classes.legendBase} ${classes.ft12}`} /><LegendBoxListItemText>FT 12H</LegendBoxListItemText>
        </LegendBoxListItem>
        <LegendBoxListItem>
          <span className={`${classes.legendBase} ${classes.ft09}`} /><LegendBoxListItemText>FT 09H</LegendBoxListItemText>
        </LegendBoxListItem>
        <LegendBoxListItem>
          <span className={`${classes.legendBase} ${classes.ft06}`} /><LegendBoxListItemText>FT 06H</LegendBoxListItemText>
        </LegendBoxListItem>
        <LegendBoxListItem>
          <span className={`${classes.legendBase} ${classes.ft03}`} /><LegendBoxListItemText>FT 03H</LegendBoxListItemText>
        </LegendBoxListItem>
        <LegendBoxListItem style={{alignItems: "stretch"}}>
          <span className={`${classes.legendBase} ${classes.detachedVa}`} />
          <LegendBoxListItemText>
            Detached VA from previous eruption
            (Fill in cross section)
          </LegendBoxListItemText>
        </LegendBoxListItem>
        <LegendBoxListItem>
          <List>
            <ListItemText>ACOS Monitored Volcanoes</ListItemText>
            <List className={classes.flexList}>
              <LegendBoxListItem>
                <AcosToolTip title={greenText} placement="top" arrow>
                  <img src={greenImg} alt="green" className={classes.icon}></img>
                </AcosToolTip>
              </LegendBoxListItem>
              <LegendBoxListItem>
                <AcosToolTip title={yellowText} placement="top" arrow>
                  <img src={yellowImg} alt="yellow" className={classes.icon}></img>
                </AcosToolTip>
              </LegendBoxListItem>
              <LegendBoxListItem>
                <AcosToolTip title={orangeText} placement="top" arrow>
                  <img src={orangeImg} alt="orange" className={classes.icon}></img>
                </AcosToolTip>
              </LegendBoxListItem>
              <LegendBoxListItem>
                <AcosToolTip title={redText} placement="top" arrow>
                  <img src={redImg} alt="red" className={classes.icon}></img>
                </AcosToolTip>
              </LegendBoxListItem>
            </List>
          </List>
        </LegendBoxListItem>
        <LegendBoxListItem>
          <ListItemText>The volcanic rank of ACOS does not mean volcanic activity but the impact for aviation.</ListItemText>
        </LegendBoxListItem>
      </LegendBoxList>
    </Box>
  )
}

export default memo(LegendAcos);
